import axios from 'axios';
import ENV from '../../../environment';

export default {
  state: {
    options: [],
    selection: {}
  },

  mutations: {
    setOptions(state, options) {
      state.options = options;
    },

    setSelectedOption(state, option) {
      state.selection = option;
    }
  },

  actions: {
    async fetchOptions({ commit }) {
      let usages = await axios.get(ENV.baseUrl + ENV.sheetsEndpoint + "?range=dachnutzung!A1:D20" + "&pluginSetPreview=" + ENV.setPreview)
      if (!usages.data) return;

      let headers = usages.data.shift(); // Get the first row, which contains the header names

      usages = usages.data.map((row, index) => {
        // Map headers to row
        let rowAsObject = {};
        headers.forEach((header, index) => {
          rowAsObject[header] = row[index];
        });

        row = rowAsObject;

        let usage = {
          name: row["Optionen"],
          randfixierung: row["Randfixierung"] == "Ja",
          position: index,
          texts: {
            title: row["Titel"],
            body: row["Text"]
          }
        };

        return usage;
      })


      commit('setOptions', usages);
    },

    selectOption ({ commit }, option) {
      commit('setSelectedOption', option);
    }
  },

};
